// useUsuariosTrs.js
import { useEffect, useState } from "react";
import { getUsuariosTrs } from "../services/reqSolicitudes";

// No son técnicos: se ocultan del selector "Filtrar por Técnico" (y de cualquier otro
// picker que use este hook). "Cliente" no es un rol propio, es role='user' + sub_rol='cli'.
const esNoTecnico = (u) =>
  u?.role === "tele" || u?.role === "marqueting" || (u?.role === "user" && u?.sub_rol === "cli");

export function useUsuariosTrs() {
  const [usuarios, setUsuarios] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [errorUsuarios, setErrorUsuarios] = useState(null);

  const fetchUsuarios = async () => {
    setLoadingUsuarios(true);
    setErrorUsuarios(null);
    try {
      const { data } = await getUsuariosTrs({ estado: "A" });
      setUsuarios(Array.isArray(data) ? data.filter((u) => !esNoTecnico(u)) : []);
    } catch (err) {
      console.error("Error cargando usuarios TRS:", err);
      setErrorUsuarios("No se pudieron cargar los usuarios.");
      setUsuarios([]);
    } finally {
      setLoadingUsuarios(false);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  return { usuarios, loadingUsuarios, errorUsuarios, refetchUsuarios: fetchUsuarios };
}
